import { render } from "./LabelMonitoring.vue?vue&type=template&id=6ff6056f&scoped=true"
import script from "./LabelMonitoring.vue?vue&type=script&lang=js"
export * from "./LabelMonitoring.vue?vue&type=script&lang=js"

import "./LabelMonitoring.vue?vue&type=style&index=0&id=6ff6056f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff6056f"]])

export default __exports__